import * as React from 'react';
import '../index.css';
import {
  shadowTop1, shadowTop2, shadowTop3,
  shadowRight1, shadowRight2, shadowRight3,
  shadowDown1, shadowDown2, shadowDown3,
  shadowLeft1, shadowLeft2, shadowLeft3
} from '@riiid/santa-closet-web';
import Highlight from 'react-highlight';
import withStyles from "react-jss";

const styles = {
  wrap: {
    '& > div': {
      display: 'flex',
      '& > span': {
        width: 100,
        padding: '30px 5px',
        margin: '20px 15px',
        background: '#eee'
      }
    }
  }
};

const StyledShadows = ({classes}) => {
  return (
    <div className={classes.wrap}>
      <div>
        <span style={{boxShadow:shadowTop1}}>shadowTop1</span>
        <span style={{boxShadow:shadowRight1}}>shadowRight1</span>
        <span style={{boxShadow:shadowDown1}}>shadowDown1</span>
        <span style={{boxShadow:shadowLeft1}}>shadowLeft1</span>
      </div>
      <div>
        <span style={{boxShadow:shadowTop2}}>shadowTop2</span>
        <span style={{boxShadow:shadowRight2}}>shadowRight2</span>
        <span style={{boxShadow:shadowDown2}}>shadowDown2</span>
        <span style={{boxShadow:shadowLeft2}}>shadowLeft2</span>
      </div>
      <div>
        <span style={{boxShadow:shadowTop3}}>shadowTop3</span>
        <span style={{boxShadow:shadowRight3}}>shadowRight3</span>
        <span style={{boxShadow:shadowDown3}}>shadowDown3</span>
        <span style={{boxShadow:shadowLeft3}}>shadowLeft3</span>
      </div>
      <Highlight language="javascript" className="code-block">
        {`import {shadowTop1} from '@riiid/santa-closet-web';

  export class Example extends Component {
    render () {
      return <div  style={{boxShadow:shadowLeft1}}/>
    }
  }`}
      </Highlight>
    </div>
  )
};

const Shadows = withStyles(styles)(StyledShadows);

export default Shadows;



// WEBPACK FOOTER //
// ./src/components/Shadows.js